import { IUser } from 'store/authSlice'
import { api } from './api'

interface ILoginResponse {
  token: string
  user: IUser
}

export interface IPhoneLoginResponse {
  token?: {
    Session?: string
    ChallengeParameters?: {
      USERNAME: string
      phone: string
    }
  }
}

export interface IUserInfo {
  data: any
}

export const authApi = api.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<ILoginResponse, any>({
      query: (credentials: any) => ({
        url: 'authentication/login',
        method: 'POST',
        body: credentials
      })
    }),
    shopifyLogin: build.mutation<ILoginResponse, any>({
      query: (credentials: any) => {
        const url = 'authentication/shopify-login';
        const fullUrl = `${process.env.REACT_APP_SUREFIRE_API}/${url}`;
        
        console.log('🔧 shopifyLogin mutation - Request details:', {
          url,
          fullUrl,
          method: 'POST',
          body: {
            shop: credentials.shop,
            token: credentials.token ? `${credentials.token.substring(0, 10)}...` : null
          },
          baseUrl: process.env.REACT_APP_SUREFIRE_API
        });

        return {
          url,
          method: 'POST',
          body: credentials
        };
      }
    }),
    confirmSignup: build.mutation<
      any,
      { username: string; confirmation_code: string }
    >({
      query: (body) => ({
        url: 'authentication/confirm-signup',
        method: 'POST',
        body
      })
    }),
    resendConfirmation: build.mutation<
      any,
      {
        email: string
      }
    >({
      query: (body) => ({
        url: 'authentication/resend-confirmation',
        method: 'POST',
        body
      })
    }),
    signup: build.mutation<
      ILoginResponse,
      { username: string; full_name: string; password: string }
    >({
      query: (credentials: any) => ({
        url: 'authentication/signup',
        method: 'POST',
        body: credentials
      }),
      invalidatesTags: ['Customers']
    }),
    forgotPassword: build.mutation<any, { email: string }>({
      query: (credentials: any) => ({
        url: 'authentication/forgot-password',
        method: 'POST',
        body: credentials
      })
    }),
    resetPassword: build.mutation<
      any,
      { username: string; password: string; confirmation_code: string }
    >({
      query: (credentials: any) => ({
        url: 'authentication/reset-password',
        method: 'POST',
        body: credentials
      })
    }),
    confirmUser: build.mutation<any, string>({
      query: (email) => ({
        url: '/users/confirm',
        method: 'POST',
        body: {
          email
        }
      })
    }),
    getUser: build.query<IUserInfo, string>({
      query: (id) => `/api/user/${id}`,
      providesTags: (_result, _error, id) => {
        return [
          { type: 'UserInfo', id },
          { type: 'UserInfo', id: 'PARTIAL-LIST' }
        ]
      }
    })
  })
})

export const {
  useLoginMutation,
  useShopifyLoginMutation,
  useConfirmSignupMutation,
  useResendConfirmationMutation,
  useSignupMutation,
  useGetUserQuery,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useConfirmUserMutation
} = authApi
